module.exports = __webpack_public_path__ + "static/media/calendar.e70b4001.svg";